import {defineField, defineType} from 'sanity'
import {MdOndemandVideo} from 'react-icons/md'

export default defineType({
  name: 'videos-slider',
  title: 'Videos Slider',
  type: 'object',
  icon: MdOndemandVideo,
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'videos',
      title: 'Videos',
      type: 'array',
      of: [{type: 'reference', to: [{type: 'blog.video'}]}],
    }),
  ],
  preview: {
    select: {
      title: 'title',
      videos: 'videos',
    },
    prepare({title, videos}) {
      return {
        title: title,
        subtitle: videos?.length > 0 ? `${videos.length} videos` : 'No videos',
      }
    },
  },
})
